module.exports = __webpack_public_path__ + "static/logo-qdc1-7e341a0027af08a66c45f32cd9a4bc3a.png";